import React, { Component } from 'react';
import propTypes from 'prop-types';
import cn from 'classnames';

import mParticle, { ScreenViewEvent } from '~/Providers/mParticle';

import './ChooseCover.scss';
import Spinner from '~/Components/Global/Loading/Spinner';
import History from '~/Providers/History';
import CoverGallery from './CoverGallery';
import SelectedCover from './SelectedCover';

class ChooseCover extends Component {
  constructor() {
    super();
    this.state = {
      current: null,
      fetched: false,
    };
  }

  componentDidMount = () => {
    mParticle.logEvent(new ScreenViewEvent('Choose Cover'));
    this.props.getSkins();
  };

  componentWillReceiveProps = nextProps => {
    // Check UserOptions have been fetched and Skins are Loaded
    if (nextProps.fetched && !this.state.fetched && nextProps.skins && nextProps.skins.length) {
      // If Current User has a default skin Selected
      if (nextProps.match.params.cover) {
        nextProps.skins.map(skin => {
          if (skin.id === parseInt(nextProps.match.params.cover)) {
            this.setState({
              // Set user selected skin as current
              current: skin,
            });
          }
        });
      } else if (nextProps.userOptions.skin?.id) {
        // Find Current selected skin
        nextProps.skins.map(skin => {
          if (skin.id === nextProps.userOptions.skin.id) {
            this.setState({
              // Set user selected skin as current
              current: skin,
            });
          }
        });
      } else {
        // If no skin is set for current user Set current
        this.setState({
          current: nextProps.skins[0],
        });
      }
      // Set state to fetched to avoid infinite loops
      this.setState({
        fetched: true,
      });
    }
  };

  render() {
    const { isFetching, updateSkin, userOptions, skins, match } = this.props;
    const { current } = this.state;
    const setCurrentCover = current => {
      this.setState({
        current,
      });
      History.push(`/choose-cover-list/${current.id}`);
    };
    if (!skins.length) {
      return (
        <div className="cover-select-spinner">
          <Spinner />
        </div>
      );
    } else {
      return (
        <div className="cover-select-parent" ref={c => (this.selector = c)}>
          <div
            className={cn('cover-select-child selected-cover', { selected: match.params.cover })}
          >
            <SelectedCover
              currentCover={current}
              userOptions={userOptions}
              updateSkin={updateSkin}
              isFetching={isFetching}
            />
          </div>
          <div className={cn('cover-select-child gallery', { selected: !match.params.cover })}>
            <CoverGallery skins={skins} setCurrent={setCurrentCover} />
          </div>
        </div>
      );
    }
  }
}

ChooseCover.propTypes = {
  userOptions: propTypes.object,
  updateSkin: propTypes.func,
  getSkins: propTypes.func,
  isFetching: propTypes.bool,
  fetched: propTypes.bool,
  skins: propTypes.array,
  match: propTypes.object,
};

export default ChooseCover;
